import React, { lazy, memo } from 'react'
import SuspenseWithCatch from '../ui/SuspenseWithCatch'
import SomethingWentWrong from '../ui/SomethingWentWrong'
import type { OwnProps } from './LockScreen'
import useSaved from '../../hooks/useSaved'
import { Bundles, loadBundle } from '../../util/moduleLoader'

const LockScreenAsync = lazy(() => loadBundle(Bundles.Main).then((bundle) => ({ default: bundle.LockScreen })))

const LockScreen = (props: OwnProps) => {
  // eslint-disable-next-line react/destructuring-assignment
  if (!useSaved(props.isLocked || null)) return null

  return (
    <SuspenseWithCatch fallback={<SomethingWentWrong />}>
      <LockScreenAsync {...props} />
    </SuspenseWithCatch>
  )
}

export default memo(LockScreen)
